import GTMService from "../services/GTMService";

const InteractionSelfieOnly = {

    ConfirmarIdentidadeNoneTermsOfUse : {
        lb: 'none_selfieOnly_termsOfUse',
        type : GTMService.TypeIn().link,
    },
    ConfirmarIdentidadeStartTermsOfUse : {
        lb: 'start_selfieOnly_termsOfUse',
        type : null,
    },
    SelfieIntroducao : {
        lb: 'none_selfieOnly_takeSelfie',
        type : null,
    },
    ModalCamera: {
        lb: 'none_selfieOnly_allowCameraUse',
        type : null,

    },
    DicasSelfie: {
        lb: 'none_selfieOnly_showSelfieTips',
        type : GTMService.TypeIn().link,
    },
    SelfieError: {
        lb: 'selfieError2_tentarNovamente_selfieOnly',
        type : null,
    },
    Analise: {
        lb: 'step2_selfieOnly_retryToSendData',
        type : null,
    },

    HeaderDefaultConfirm: {
        lb : "exit_none_confirm",
        type : null,
        fluxo: false
    },

    HeaderDefaultExit: {
        lb : "exit_none_back",
        type : null,
        fluxo: false
    }

}

const InteractionDoc = {
    ConfirmarIdentidadeNoneTermsOfUse : {
        lb    : 'none_doc_termsOfUse',
        type  : GTMService.TypeIn().link,
    },
    ConfirmarIdentidadeStartTermsOfUse : {
        lb: 'start_doc_termsOfUse',
        type : null,
    },
    SelfieIntroducao : {
        lb: 'none_doc_takeSelfie',
        type : null,
    },
    ModalCamera: {
        lb: 'none_doc_allowCameraUse',
        type : null,
    },
    DicasSelfie: {
        lb: 'none_doc_showSelfieTips',
        type : GTMService.TypeIn().link,
    },
    SelfieError: {
        lb: 'selfieError_tentarNovamente_doc',
        type : null,
    },
    DocSelecaoDriversLicense : {
        lb: 'none_doc_driversLicense',
        type : null,
    },
    DocSelecaoCnhDigital : {
        lb: 'none_doc_cnhDigital',
        type: null,
    },
    DocSelecaoIdCard : {
        lb: 'none_doc_idCard',
        type : null,
    },
    DocSelecaoOtherDocuments : {
        lb: 'none_doc_otherDocuments',
        type : null,
    },
    DocIntroducaoCnhFront: {
        lb: 'none_doc_takeDriversLicenseFrontPicture',
        type : null,
    },
    DocIntroducaoCnhBack: {
        lb: 'none_doc_takeDriversLicenseBackPicture',
        type : null,
    },
    DocIntroducaoRgFront: {
        lb: 'none_doc_takeIdCardFrontPicture',
        type : null,
    },
    DocIntroducaoRgBack: {
        lb: 'none_doc_takeIdCardBackPicture',
        type : null,
    },
    DocIntroducaoOutrosFront: {
        lb: 'none_doc_takeOtherDocumentsFrontPicture',
        type : null,
    },
    DocIntroducaoOutrosBack: {
        lb: 'none_doc_takeOtherDocumentsBackPicture',
        type : null,
    },
    ConfirmDocCnhFront: {
        lb: 'confirmation_doc_driversLicenseFrontPictureChecked',
        type : null,
    },
    ConfirmDocCnhBack: {
        lb: 'confirmation_doc_driversLicenseBackPictureChecked',
        type : null,
    },
    ConfirmDocRgFront: {
        lb: 'confirmation_doc_idCardFrontPictureChecked',
        type : null,
    },
    ConfirmDocRgBack: {
        lb: 'confirmation_doc_idCardBackPictureChecked',
        type : null,
    },
    ConfirmDocOutrosFront: {
        lb: 'confirmation_doc_otherDocumentsFrontPictureChecked',
        type : null,
    },
    ConfirmDocOutrosBack: {
        lb: 'confirmation_doc_otherDocumentsBackPictureChecked',
        type : null,
    },
    RetakeDocCnhFront: {
        lb: 'none_doc_retakeDriversLicenseFrontPicture',
        type : null,
    },
    RetakeDocCnhBack: {
        lb: 'none_doc_retakeDriversLicenseBackPicture',
        type : null,
    },
    RetakeDocRgFront: {
        lb: 'none_doc_retakeIdCardFrontPicture',
        type : null,
    },
    RetakeDocRgBack: {
        lb: 'none_doc_retakeIdCardBackPicture',
        type : null,
    },
    RetakeDocOutrosFront: {
        lb: 'none_doc_retakeOtherDocumentsFrontPicture',
        type : null,
    },
    RetakeDocOutrosBack: {
        lb: 'none_doc_retakeOtherDocumentsBackPicture',
        type : null,
    },
    PermitirAcessoDocumentosCnhDigital: {
        lb: 'none_doc_allowAccessToDocuments',
        type: null,
    },
    ErroUploadCnhDigital: {
        lb: 'error_doc_cantAttachedYourCnh',
        type: null,
    },
    Analise: {
        lb: 'step2_doc_retryToSendData',
        type : null,
    },
    HeaderDefaultConfirm: {
        lb : "exit_none_confirm",
        type : null,
        fluxo: false
    },
    HeaderDefaultExit: {
        lb : "exit_none_back",
        type : null,
        fluxo: false
    },
    DocError1: {
        lb : "error_okTentarDeNovo_documentError1",
        type : null,
    },
    DocError2: {
        lb : "error_okTentarDeNovo_documentError2",
        type : null,
    },
    DocError3: {
        lb    : "error_okTentarDeNovo_documentError3",
        type  : null,
    },
    DocError4: {
        lb    : "error_okTentarDeNovo_documentError4",
        type  : null,
    }
}

export default {
    InteractionSelfieOnly,
    InteractionDoc
}



// WEBPACK FOOTER //
// ./src/utils/enumInteraction.js